// extracted by mini-css-extract-plugin
export var brand = "_1o-9";
export var button = "_1o-0";
export var chevron = "_1o-v";
export var chevronButton = "_1o-w";
export var content = "_1o-n";
export var danger = "_1o-g";
export var dangerOutlined = "_1o-h";
export var dark = "_1o-l";
export var darkTheme = "_1o-c";
export var extraSmall = "_1o-4";
export var fullWidth = "_1o-8";
export var ghost = "_1o-d";
export var gray = "_1o-t";
export var icon = "_1o-p";
export var iconButton = "_1o-s";
export var iconButtonBorder = "_1o-x";
export var iconButtonBorderDark = "_1o-y";
export var iconButtonBorderLight = "_1o-z";
export var iconLeft = "_1o-q";
export var iconRight = "_1o-r";
export var large = "_1o-1";
export var light = "_1o-m";
export var medium = "_1o-2";
export var micro = "_1o-5";
export var nano = "_1o-7";
export var outlined = "_1o-k";
export var pending = "_1o-a";
export var primary = "_1o-i";
export var shadow = "_1o-o";
export var small = "_1o-3";
export var solidLight = "_1o-e";
export var solidLightBrand = "_1o-f";
export var spinner = "_1o-u";
export var transparent = "_1o-j";
export var warning = "_1o-b";
export var wideNano = "_1o-6";